const safelyReportedErrors = new WeakSet<object>();

const isObject = (value: unknown): value is object => (typeof value === 'object' && value !== null) || typeof value === 'function';

export const markErrorSafelyReported = (error: unknown) => {
    if (isObject(error)) safelyReportedErrors.add(error);
};

export const isErrorSafelyReported = (error: unknown) => isObject(error) && safelyReportedErrors.has(error);
